// extracted by mini-css-extract-plugin
export default {"rating":"Pcnmb__rating","ratingCount":"mPd6A__ratingCount theme-accent","ratingStar":"S1AR3__ratingStar"};